import { withInstall } from '@code-monkey-ui/utils'
import Progress from './src/progress.vue'

export const ElProgress = withInstall(Progress)
export default ElProgress

export * from './src/progress'
